import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { hasRequiredRole } from "../../utils/authRoles";

export default function ProtectedRoute({ requiredRole }) {
  const { authUser, loading } = useAuth();

  if (loading) {
    return null;
  }

  if (!authUser) {
    return <Navigate to="/login" replace />;
  }

  if (!hasRequiredRole(authUser.role, requiredRole)) {
    return <Navigate to="/not-authorized" replace />;
  }

  return <Outlet />;
}